import { render, staticRenderFns } from "./d-book-submission-min-date.vue?vue&type=template&id=b0f16132&"
import script from "./d-book-submission-min-date.vue?vue&type=script&lang=js&"
export * from "./d-book-submission-min-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports